import { render, staticRenderFns } from "./XsscDetail.vue?vue&type=template&id=4bc86048&scoped=true&"
import script from "./XsscDetail.vue?vue&type=script&lang=js&"
export * from "./XsscDetail.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./XsscDetail.vue?vue&type=style&index=1&id=4bc86048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc86048",
  null
  
)

export default component.exports